<template>
    <img :src="member.avatar || '/static/images/avatar.jpg'" :alt="member.first_name" class="img-responsive img-circle pull-left">
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'Avatar',
        computed: {
            ...mapGetters({
                member: 'getMember'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/profile/components/Avatar.vue